<script>
import Legal from "./Types/Legal/Index";
import Physical from "./Types/Physical";

import { mapState } from "vuex";

export default {
  components: {
    Legal,
    Physical
  },
  computed: {
    ...mapState("signUp", ["accountableType"])
  }
};
</script>

<template>
  <component :is="accountableType" />
</template>



// WEBPACK FOOTER //
// src/components/SignUp/Steps/Accountable/Index.vue